import React, { useState, useEffect } from "react";
import Layout from "../../components/layouts/layout";
import BannerBgImage from "../../assets/Images/services/consult-banner.png";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import Clm1Img from "../../assets/Icons/phone.svg";
import Clm2Img from "../../assets/Icons/mail.svg";
import BannerSection from "../../components/servicesSection/banner";
import OurOffering from "../../components/servicesSection/ourOffering";
import CtaCardSection from "../../components/CTASection/ctaCard2";
import CTAIMAGE1 from "../../assets/Images/Clutch/Cta/phone-contact.png";
import FullStackExpertise from "../../components/FullStackExpertise";
import ConsultImage from "../../assets/Images/Homepage/FullStackExpertise/audit.png";
import OurModelSection from "../../components/OurModelSection";
import SkeletonOfferingLoader from "../../components/SkeletonOfferingCard";
import FAQSection from "../../components/NewHomePage/FAQSection";

const auditFaqs = [
  {
    q:
      "What is a technology audit and why is it important for digital products?",
    a:
      "A technology audit is a comprehensive evaluation of a product's codebase, infrastructure, and overall performance. It is important because it helps identify hidden risks, technical debt, and scalability issues before they impact growth, ensuring the product is stable, secure, and ready to scale.",
  },
  {
    q: "What does DigiRyte's technology audit service include?",
    a:
      "DigiRyte's technology audit includes a detailed review of code quality, system architecture, infrastructure, security, performance, and scalability. We provide actionable insights, risk assessments, and a prioritised roadmap to improve system efficiency and readiness for growth.",
  },
  {
    q: "When should a company conduct a technology or software audit?",
    a:
      "A technology audit should be conducted before scaling a product, during rapid growth, before major investments or funding rounds, when facing performance issues, or when planning system modernisation.",
  },
  {
    q:
      "How does a technical audit help identify risks before scaling a platform?",
    a:
      "A technical audit uncovers potential bottlenecks, architectural limitations, security vulnerabilities, and inefficiencies. By addressing these risks early, businesses can avoid downtime, performance failures, and costly rework during scaling.",
  },
  {
    q:
      "What types of systems or products can be reviewed during a technology audit?",
    a:
      "Technology audits can be performed on web applications, mobile apps, SaaS platforms, enterprise systems, APIs, and legacy systems. Any digital product that supports business operations can benefit from an audit.",
  },
  {
    q:
      "How does DigiRyte evaluate software architecture and code quality during an audit?",
    a:
      "DigiRyte uses a combination of automated tools and expert review to assess code structure, maintainability, design patterns, and architectural decisions. This ensures the system follows best practices and is built for scalability and long-term sustainability.",
  },
  {
    q: "Can a technology audit identify technical debt in existing systems?",
    a:
      "Yes, one of the key objectives of a technology audit is to identify technical debt. This includes outdated code, inefficient processes, and shortcuts taken during development that may impact performance and future scalability.",
  },
  {
    q: "How does an audit assess the scalability of a digital platform?",
    a:
      "An audit evaluates how well the system can handle increased users, data, and workloads. It reviews architecture design, infrastructure setup, database performance, and load-handling capabilities to ensure the platform can scale without failure.",
  },
  {
    q: "What is included in a technical risk assessment?",
    a:
      "A technical risk assessment identifies vulnerabilities related to performance, security, scalability, and system reliability. It highlights critical risks, their potential impact, and provides recommendations to mitigate them effectively.",
  },
  {
    q:
      "Do technology audits help prepare products for funding or enterprise adoption?",
    a:
      "Yes, a technology audit strengthens investor and stakeholder confidence by demonstrating that the product is robust, secure, and scalable. It also ensures the system meets the standards required for enterprise adoption.",
  },
  {
    q: "How long does a typical technology audit engagement take?",
    a:
      "The duration depends on the technical intricacy of the system. Most audits take between 2 to 6 weeks, but larger or more complex platforms may require additional time for thorough evaluation.",
  },
  {
    q: "What deliverables do businesses receive after a technology audit?",
    a:
      "Businesses receive a comprehensive audit report that includes identified issues, risk levels, performance insights, and a prioritised action plan. The report is designed to be practical and easy to implement.",
  },
  {
    q:
      "How can a technology audit improve product performance and reliability?",
    a:
      "By identifying inefficiencies, bottlenecks, and weak points, a technology audit enables targeted improvements. This results in faster performance, reduced downtime, improved user experience, and overall system stability.",
  },
  {
    q: "Do you provide fixed-scope or fixed-price audit engagements?",
    a:
      "Yes, DigiRyte offers both fixed-scope and flexible engagement models depending on the client's needs. This ensures transparency in cost and clarity in deliverables from the outset.",
  },
  {
    q:
      "Why should organisations choose DigiRyte for technology audit services?",
    a:
      "DigiRyte combines deep technical expertise with a practical, results-driven approach. We go beyond identifying issues by providing actionable recommendations and supporting implementation, helping businesses confidently scale and optimise their digital products.",
  },
];

function AuditScreen() {
  // Import Sanity service inside component to avoid build-time issues
  const { SanityService } = require("../../services/sanity");

  // State for dynamic offerings
  const [offerList, setOfferList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Fallback static data

  // Fetch offerings from Sanity on component mount
  useEffect(() => {
    const fetchOfferings = async () => {
      try {
        setLoading(true);
        setError(null);
        const sanityOfferings = await SanityService.getOfferingsByPageType(
          "audit",
        );
        setOfferList(sanityOfferings || []);
      } catch (error) {
        console.error("Error fetching offerings:", error);
        setError("Failed to load offerings. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchOfferings();
  }, []);

  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };
  const BoxData = {
    boxBtn1Width: "230px",
    boxBtn1Height: "46px",
    boxBtn1variant: "contained",
    boxBtn1color: "primary",
    boxBtn1label: "Career",
    tip: "Career",
    tooltip: "no",
    Clm2SubTitle: "careers@digiryte.com",
    boxBtn1Title: "Join our team",
    boxBtn1SubTitle: (
      <>
        If you're a designer or a developer <br /> who loves to challenge
        conventions,
        <br /> make the ryte move!
      </>
    ),
    boxBtn2Width: "230px",
    boxBtn2Height: "46px",
    boxBtn2variant: "contained",
    boxBtn2color: "primary",
    boxBtn2label: "Call us right now",
    boxBtn2Title: "Let’s talk",
    tip1: "Call us right now",
    boxBtn2SubTitle: (
      <>
        Have you got an exciting project that <br /> you'd like to discuss?{" "}
      </>
    ),
    route1: "/contact-us",
    route2: "/contact-us",
  };

  return (
    <Layout
      seo={{
        title: "Service - Audit | DigiRyte",
        ogtitle: "Service - Audit | DigiRyte",
        description: "Audit",
        keywords:
          "Cost Optimization Analysis & cloud Services, Corporate innovation Assessment, Technology stack Audit services, Code & UX Audit services, Cloud Security Assessment services, Performance & Efficiency Audit services, Cloud Migration Readiness Assessment services, Compliance Audit services, CREST Penetration Testing services, Pre-Investment Risk Assessment services, Tech & Talent Due Diligence services",
      }}
    >
      <BannerSection
        bannerImage={BannerBgImage}
        title="Audit"
        subtitle={<>Tech & Risk Review</>}
        image={ConsultImage}
      />

      <div className="mt-40">
        <div className="body-container">
          {loading ? (
            <SkeletonOfferingLoader count={6} />
          ) : error ? (
            <div
              style={{
                textAlign: "center",
                padding: "100px 20px",
                minHeight: "400px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  color: "#D32F2F",
                  marginBottom: "10px",
                }}
              >
                {error}
              </p>
              <p style={{ fontSize: "14px", color: "#666" }}>
                Please refresh the page or contact support.
              </p>
            </div>
          ) : (
            <OurOffering
              title="Our Offerings"
              details="We evaluate your technology landscape through rigorous health checks and compliance reviews, helping you identify risks, assess digital maturity, and align systems for future scalability."
              CardListData={offerList}
              pageName="audit"
            />
          )}
        </div>
      </div>
      <div className="mt-70 common-o-bg">
        <CtaCardSection
          className=""
          title={
            <>
              <span className="animationTitle">Ready to </span>
              partner with us?
            </>
          }
          imageUrl={CTAIMAGE1}
          imgClassName="custom-cta-img custom-cta-darken"
        />
      </div>
      <div className="mt-50">
        <FullStackExpertise
          parentWarp="services-modal-wrap"
          title="Other Services"
          showButton={false}
          showItems={["Consult", "Build"]}
          isServiceCard
        />
      </div>
      <div className="mt-30">
        <OurModelSection />
      </div>
      <div className="mt-70">
        <FAQSection faqs={auditFaqs} />
      </div>
      <div className="mt-70">
        {/* <Box BoxData={BoxData} /> */}
        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
}

export default AuditScreen;
